import axios from '../../../context/axiosConfig'
import { useState, useEffect } from 'react';
import { usePaginationRezerwy } from '../../../context/PaginationContextRezerwy';
const RezerwyGetList = () => {
    const {pagination, setPagination} = usePaginationRezerwy()
    const [data, setData] = useState([])
    useEffect(() => {
      setPagination({...pagination, loading: true})
      const fetchData = async () => {
          const response = await axios.post("/rezerwy/get/list", {
            pagination: pagination
          });
          if(pagination.current > (response.data.total / pagination.pagesize)){
            setPagination({...pagination, current: 1})  
          }
          setPagination({...pagination, loading: false})
          setData(response.data)
      }
      fetchData()
    },[pagination.current, pagination.pagesize, pagination.reload, pagination.generated, pagination.search])
    return data
  };
export default RezerwyGetList;